import { render, staticRenderFns } from "./LlmsTemplatesEditor.vue?vue&type=template&id=2b177abd"
import script from "./LlmsTemplatesEditor.vue?vue&type=script&lang=js"
export * from "./LlmsTemplatesEditor.vue?vue&type=script&lang=js"
import style0 from "./LlmsTemplatesEditor.vue?vue&type=style&index=0&id=2b177abd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports